<template>
    <div class="session__show_dates">
        <div class="columns columns--custom is-multiline">
            <div
                class="column column--custom is-4-desktop is-9-tablet is-12-mobile"
                v-for="(session, index) in sessionOccurrences"
                :key="index"
            >
                <session-show-dates-item
                    :session="session"
                    :session-index="(index + 1)"
                    :session-count="sessionOccurrences.length"
                />
            </div>
        </div>
    </div>
</template>

<script>
import SessionShowDatesItem from '@/components/ebs/sessions/show/SessionShowDatesItem'

export default {
  components: { SessionShowDatesItem },
  name: 'session-show-dates',
  computed: {
    sessionOccurrences: function () {
      return this.$store.getters.getSessionOccurrenceItems
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/ebs/sessions/sessionshowdates";
</style>
